export default () => {
  return 'https://ark-api.aciso-suite.com';
}
